import { IBeneficiarioPrevidenziale } from "src/app/modules/shared/models/policy.model";
import { IPrevidentialAnagraficaRequestModel, IPrevidentialRequestModel } from "../beneficiary-change-isp/beneficiary-change-isp.constants";

export enum EBeneficiaryTypeIsv {
    VITA = 'V',
    MORTE = 'M'
}

export interface IBeneficiaryChangeRequest {
    policyNumber: string;
    beneficiariesData?: ILifeDeathBeneficiary[] | IPrevidentialRequestModel[];
    thirdPartyReferrer?: IPersonDataIsv;
	previdentialBeneficiary?: IPrevidentialRequestModel[];
}

export interface IRetirementDateVariation {
	policyNumber: string;
	retirementDate: string;
}

export interface IDebitDateVariation {
	policyNumber: string;
	debitDate: string;
	effectDate: string;
}

export interface IPayerVariationUpdate {
	policyNumber?: string;
	nome: string;
	cognome: string;
	dataNascita: string;
	naturaGiuridica: 'F' | 'G';
	sesso?: string;
	codiceFiscale: string;
	idAnagrafico: string;
	indirizzoNascita: IAddress;
	documento: IDocumentUpdate;
}

export interface IDocumentUpdate {
	idDocumento?: string | null;
	codiceDocumentoRiconoscimento: string;
	numeroDocumento: string;
	dataRilascio: string;
	dataFineValidita: string;
	codiceEnteRilascio: string;
	luogoRilascio: string;
	descrizioneTipoDocumento: string;
	descrizioneEnteRilascio: string;
	timestamp?: string;
}


export interface IAddress {
	cap: string;
	via: string;
	localita: string;
	provincia: string;
	codiceNazione: string;
}


export interface IBeneficiaryChangeRequestPrevidential {
    policyNumber: string;
    beneficiario: IBeneficiarioPrevidenziale[]
}


export interface ILifeDeathBeneficiary {
	beneficiaryCategory?: string;
	beneficiaryType?: any;
	description?: string;
	beneficiary?: string;
	beneficiaries: IBeneficiariesIsv[];
	beneficiaryPrevidential?: IPrevidentialRequestModel
	anagrafichePrevidenziali?: IPrevidentialAnagraficaRequestModel[];
}

export interface IBeneficiariesIsv {
	insuredBeneficiaryRelashionshipCode?: string;
	holderBeneficiaryRelashionshipCode: string;
	personData?: IPersonDataIsv;
}
export interface IPersonDataIsv {
	birthDate?: string;
	personType: string;
	addresses?: IAddressIsv[];

	fiscalCode?: string;
	lastName?: string;
	firstName?: string;
	contact?: IContactIsv;

	vatCode?: string;
	businessName?: string;
}

export interface IAddressIsv {
	nationCode: string;
	provinceCode: string;
	city: string;
	nation: string;
	province: string;
	addressType: string;
	zipCode?: string;
	street?: string;
}

export interface IContactIsv {
	phoneNumber?: string;
	email?: string;
}